import { withRouter } from 'react-router-dom';

export default () => Component => withRouter(Component);
